import { NgModule } from "@angular/core";
import { CacheInfo, CacheInfoMetadata, DataSourceAdminServiceInfo, DataSourceAdminServiceInfoMetadata, EntityMetadata, JavaThrowable, JavaThrowableMetadata, Privilege, PrivilegeMetadata, PropertyMetadata, RelationshipType, Role, RoleMetadata, ScheduledServiceInfo, ScheduledServiceInfoMetadata, ServerErrorHttpInfo, ServerErrorHttpInfoMetadata, ServerErrorHttpRequestInfo, ServerErrorHttpRequestInfoMetadata, ServerErrorHttpResponseInfo, ServerErrorHttpResponseInfoMetadata, ServerErrorInfo, ServerErrorInfoMetadata, UimCommonModule, User, USER_DETAILS_ATTRIBUTES_METADATA, UserDetailsAttributes, UserDetailsAttributesMetadata, UserDetailsView, UserDetailsViewMetadata, UserDetailsWithAttributes, UserDetailsWithAttributesMetadata, UserMetadata, UserSessionActivity, UserSessionActivityMetadata, UserSessionAdminServiceInfo, UserSessionAdminServiceInfoMetadata, UserTypeInfo, UserTypeInfoMetadata } from "@scisys-uim/uim-common";
import { baseRegisterAssetsModelCrudEntityConstructors } from "./assets-model.module.base";
import { AssetsUserDetails } from "./domain/userdetails/model/assets-user-details.model";
import { AssetsUserDetailsMetadata } from "./domain/userdetails/model/assets-user-details.metadata";
import { BUSINESS_UNIT_METADATA } from "./domain/businessunit/model/business-unit.metadata";

export function registerAssetModelCrudEntityConstructors() {
  PrivilegeMetadata.prototype.constructorFunction = Privilege;
  RoleMetadata.prototype.constructorFunction = Role;
  UserMetadata.prototype.constructorFunction = User;
  CacheInfoMetadata.prototype.constructorFunction = CacheInfo;
  DataSourceAdminServiceInfoMetadata.prototype.constructorFunction = DataSourceAdminServiceInfo;
  JavaThrowableMetadata.prototype.constructorFunction = JavaThrowable;
  ServerErrorHttpRequestInfoMetadata.prototype.constructorFunction = ServerErrorHttpRequestInfo;
  ServerErrorHttpResponseInfoMetadata.prototype.constructorFunction = ServerErrorHttpResponseInfo;
  ServerErrorHttpInfoMetadata.prototype.constructorFunction = ServerErrorHttpInfo;
  ServerErrorInfoMetadata.prototype.constructorFunction = ServerErrorInfo;
  ScheduledServiceInfoMetadata.prototype.constructorFunction = ScheduledServiceInfo;
  UserDetailsAttributesMetadata.prototype.constructorFunction = UserDetailsAttributes;
  UserDetailsWithAttributesMetadata.prototype.constructorFunction = UserDetailsWithAttributes;
  UserDetailsViewMetadata.prototype.constructorFunction = UserDetailsView;
  UserTypeInfoMetadata.prototype.constructorFunction = UserTypeInfo;
  UserSessionAdminServiceInfoMetadata.prototype.constructorFunction = UserSessionAdminServiceInfo;
  UserSessionActivityMetadata.prototype.constructorFunction = UserSessionActivity;

  // generated Entities
  baseRegisterAssetsModelCrudEntityConstructors();

  const businessUnitProperty: PropertyMetadata = {
    name: 'businessUnit',
    type: 'BusinessUnit',
    plural: false,
    isIdentity: false,
    derived: false,
    required: false,
    readOnly: false,
    readable: true,
    writeable: true,
    relationship: true,
    relationshipType: RelationshipType.ManyToOne,
    get relationshipEntityMetadata(): EntityMetadata {
      return BUSINESS_UNIT_METADATA;
    },
    byReference: true,
    unique: false
  };

  AssetsUserDetailsMetadata.prototype.constructorFunction = AssetsUserDetails;
  USER_DETAILS_ATTRIBUTES_METADATA.addProperty(businessUnitProperty);


  /*const provider = () => {
    return [
      beatsProperty,
      districtProperty
    ];
  };*/
  //UserDetailsAttributesMetadata.prototype?.propertyProviders?.push(provider);
  //addMetadataPropertyProviderToType(provider, UserDetailsAttributesMetadata);
  //console.log(USER_DETAILS_ATTRIBUTES_METADATA)
}


@NgModule({
  declarations: [
  ],
  imports: [
    UimCommonModule,
  ],
  exports: [
  ]
})
export class AssetsModelModule { }
